<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-09 15:38:39
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-18 10:58:34
 * @name: 主组件
 * @Description: 主组件
 * @FilePath: \preSaleNafterSaleInside\project\src\App.vue
 * @Author: desktop
-->
<template>
  <div id="app">
    <keep-alive :include="cashRouters">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "App",
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    },
  },
};
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>